import axios from 'axios'
import _get from 'lodash/get'
import { store } from 'store'
import { signInFail, signOutSuccess } from 'store/actions/auth'
import i18n from 'i18next'
import { ApiUrl } from 'common/Globals'

const { dispatch } = store

const source = axios.CancelToken.source()
const instance = axios.create({
    baseURL: ApiUrl,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    },
    cancelToken: source.token
})

instance.interceptors.request.use(
    (config) => {
        if (config.baseURL === ApiUrl && !config.external && !config.headers.Authorization) {
            const token = _get(store.getState(), 'auth.access_token', null)
            if (token) {
                config.headers.Authorization = `Bearer ${token}`
            }
        }
        return config
    },
    (error) => Promise.reject(error)
)

// Add a 401 response interceptor
instance.interceptors.response.use(
    function (response) {
        return response
    },
    function (error) {
        if (401 === error.response?.status) {
            const token = _get(store.getState(), 'auth.access_token', null)

            if (token) {
                console.error('401 Unauthorized')
                console.error('Logout cause response:', error)
                dispatch(signInFail({ message: error.response?.data?.message || i18n.t('sessionExpired') }))
                dispatch(signOutSuccess())
            }
        } else {
            return Promise.reject(error)
        }
    }
)

export default instance
